export default __webpack_public_path__ + "static/media/Issues_Desktop.903b2f77.svg";